<div class="memorial-nudge" (click)="event()">
  <div class="inner-div">
    <div class="icon-div"><img loading="lazy" data-src="/assets/images/heart-in-hand.png" alt="heart-in-hand"></div>
    <div class="text">{{cause?.info_1}}</div>
  </div>
  <div class="donate">
    <div class="text"> {{cause?.info_2}} </div>
    <i class="material-icons">arrow_forward</i>
  </div>
</div>